import { createStore } from 'redux-dynamic-modules';
import { getSagaExtension } from 'redux-dynamic-modules-saga';

import { getSnackbarModule } from '@/features/Snackbar/Snackbar.module';

import { getReviewsModule } from './reviews/Reviews.module';
import { getUserModule } from './user/User.module';

export const store = createStore(
  {
    enhancers: [],
    extensions: [getSagaExtension({})],
    initialState: {},
  },
  getReviewsModule(),
  getSnackbarModule(),
  getUserModule()
);
